export const MAX_PRESET_FILTER_COUNT = 15;

export const ALL_TYPES_OF_PRESETS = 'All';
